import React, { Dispatch, SetStateAction } from "react";
import clsx from "clsx";
import { ConditionPreset } from "../../../../../../models/Entities";
import { Badge, Typeahead } from "@merge-api/merge-javascript-shared";
import size from "lodash/size";

export type IntegrationWithConditionPresets = {
  conditionPresets: Partial<ConditionPreset>[];
  id?: string | undefined;
  name?: string | undefined;
  square_image?: string | undefined;
};

type IntegrationSelectProps = {
  className?: string;
  integration?: IntegrationWithConditionPresets;
  setIntegration: Dispatch<SetStateAction<IntegrationWithConditionPresets | undefined>>;
  integrations: IntegrationWithConditionPresets[];
};

const IntegrationSelect = ({
  className,
  integration,
  setIntegration,
  integrations,
}: IntegrationSelectProps) => {
  const handleIntegrationChange = (integration: IntegrationWithConditionPresets | null) => {
    if (integration) {
      setIntegration(integration);
    }
  };
  return (
    <div className={clsx("", className)}>
      <Typeahead
        options={integrations}
        value={integration}
        getOptionLabel={({ name }) => name!}
        disableClearable
        onChange={(_, integration) => handleIntegrationChange(integration)}
        renderOption={({ name, square_image, conditionPresets }) => {
          return (
            <div className="flex flex-row w-full items-center justify-between">
              <div>
                <img
                  src={square_image}
                  alt={name}
                  className="w-4 h-4 object-cover rounded-full bg-white mr-1.5"
                />
                {name}
              </div>
              <Badge color="blue" className="mr-3">
                {size(conditionPresets)} filter{size(conditionPresets) > 1 && "s"}
              </Badge>
            </div>
          );
        }}
      />
    </div>
  );
};

export default IntegrationSelect;
